import { EDomesticDealType, EFlightDealType, EPackageDealType, EShowDealType } from './interfaces.js';
export const PACKAGE_DYNAMIC_CATEGORIES = [
    { value: EPackageDealType.Package, label: 'Package - חבילת נופש' },
    { value: EPackageDealType.Ski, label: 'SKI - חבילת סקי' },
    { value: EPackageDealType.Event, label: 'Shows - חבילת הופעה' },
    { value: EPackageDealType.Sport, label: 'Sport - חבילת ספורט' },
    { value: EPackageDealType.Kosher, label: 'Kosher - חבילה כשרה' },
    { value: EPackageDealType.OrganizedTour, label: 'Org - טיול מאורגן' },
    { value: EPackageDealType.Cruise, label: 'Cruise - טיול שיט' },
    { value: EPackageDealType.SummerDeals, label: 'Summer Deals - דילים לקיץ' },
    { value: EPackageDealType['FLT+HTL+CAR'], label: 'Holiday Village + Car - כפרי נופש + רכב' },
    { value: EPackageDealType.WaterParks, label: 'Water Parks - פארקי מים' },
    { value: EPackageDealType.TishreiHolidays, label: 'Tishrei Holidays - חגי תשרי' },
    { value: EPackageDealType.Christmas, label: 'Christmas Packages - חבילות בכריסמס' },
    { value: EPackageDealType.Sylvester, label: 'Sylvester - סילבסטר' },
];
export const FLIGHT_DYNAMIC_CATEGORIES = [
    { value: EFlightDealType.RoundTrip, label: 'Round Trip - הלוך חזור', frozen: true, hidden: true },
    { value: EFlightDealType.OneWay, label: 'One Way - כיוון אחד', frozen: true, hidden: true },
    { value: EFlightDealType.FlightsToIsrael, label: 'Flights To Israel - טיסות לישראל', frozen: true, hidden: true },
    { value: EFlightDealType.OneWayBundle, label: 'One Way Bundle - חבילת כיוון אחד', frozen: true, hidden: true },
    { value: EFlightDealType.TishreiHolidaysFlights, label: 'Tishrei Holidays Flights - טיסות בחגי תשרי' },
    { value: EFlightDealType.ChristmasFlights, label: 'Christmas Flights - טיסות בכריסמס' },
    ...PACKAGE_DYNAMIC_CATEGORIES,
];
export const DOMESTIC_DYNAMIC_CATEGORIES = [
    { value: EDomesticDealType.Regular, label: 'Regular - חבילה רגילה' },
    { value: EDomesticDealType.SpaPackage, label: 'Spa - חבילת ספא' },
    { value: EDomesticDealType.ShowsPackage, label: 'Shows - חבילת חופשה/הצגה' },
    { value: EDomesticDealType.KosherPackage, label: 'Kosher - חבילה כשרה' },
    { value: EDomesticDealType.FamilyPackage, label: 'Family - חבילה משפחתית' },
    { value: EDomesticDealType.IndependenceDay, label: 'Independence Day - יום העצמאות' },
    { value: EDomesticDealType.Shavuot, label: 'Shavuot - שבועות' },
    { value: EDomesticDealType.TuBav, label: "Tu B'Av - ט״ו באב" },
    { value: EDomesticDealType.TishreiHolidays, label: 'Tishrei Holidays - חגי תשרי' },
    { value: EDomesticDealType.Hanukkah, label: 'Hanukkah - חנוכה' },
];
export const SHOWS_DYNAMIC_CATEGORIES = [{ value: EShowDealType.TuBav, label: "Tu B'Av - ט״ו באב" }];
//# sourceMappingURL=dynamic-categories.js.map